<script>
  import { MANGA_URL, DEFAULT_WALLPAPER } from '../../os/wallpapers.js';

  let {
    missionControlOpen = false, reduceTransparency = false, reduceMotion = false,
    highContrast = false, hasFullscreen = false, desktopTint = '', wallpaper = '',
    textScale = 1, children
  } = $props();

  const isManga = $derived(wallpaper === 'manga');
  const bgImage = $derived(isManga ? MANGA_URL : wallpaper || DEFAULT_WALLPAPER);
</script>

<main
  class="desktop"
  class:mission-control-active={missionControlOpen}
  class:reduce-transparency={reduceTransparency}
  class:reduce-motion={reduceMotion}
  class:high-contrast={highContrast}
  class:has-fullscreen={hasFullscreen}
  class:manga={isManga}
  data-tint={desktopTint || undefined}
  style={`--text-scale:${textScale};background-image:url("${bgImage}")`}
>
  {@render children()}
</main>

<style>
  .desktop {
    position: relative; height: 100vh; width: 100vw; overflow: hidden; user-select: none;
    background-color: #10151d;
    background-size: cover; background-position: center; background-repeat: no-repeat;
    font-size: calc(16px * var(--text-scale, 1));
  }
  .desktop.manga {
    image-rendering: pixelated;
    background-size: 2000px auto; background-repeat: repeat; background-position: 0 0;
    animation: manga-wallpaper-loop 18s linear infinite;
  }
  .desktop.reduce-transparency :global(.menubar), .desktop.reduce-transparency :global(.dock) { backdrop-filter: none; }
  .desktop.reduce-motion, .desktop.reduce-motion :global(*) {
    animation-duration: 0.001ms !important; animation-iteration-count: 1 !important;
    scroll-behavior: auto !important; transition-duration: 0.001ms !important;
  }
  .desktop.high-contrast { filter: contrast(1.22); }

  .desktop.has-fullscreen :global(.window:not(.win-fullscreen)) { display: none; }
  .desktop.mission-control-active :global(.menubar) { display: none !important; }
  @keyframes manga-wallpaper-loop { 0% { background-position: 0 0; } 100% { background-position: 4000px 4000px; } }
  @media (prefers-reduced-motion: reduce) {
    .desktop { animation: none; }
    :global(.boot-bar-fill) { animation: none; width: 100%; }
    :global(.dock-item) { transition: none; }
  }
  @media (max-width: 760px) {
    .desktop { min-height: 100vh; height: auto; overflow: auto; padding: 32px 10px 92px; }
    :global(.menubar) { position: fixed; inset: 0 0 auto 0; overflow-x: auto; white-space: nowrap; }
    :global(.menubar .status), :global(.menubar .spotlight) { display: none; }
    :global(.window) { position: relative !important; left: auto !important; top: auto !important; width: 100% !important; margin: 12px 0; }
    :global(.window.finder-window) { min-width: 0; min-height: 0; }
    :global(.resize-handle) { display: none; }
    :global(.titlebar) { touch-action: none; }
    :global(.body) { max-height: none; overflow: visible; }
    :global(.dock) { position: fixed; left: 8px; right: 8px; bottom: 8px; transform: none; justify-content: flex-start; width: auto; min-height: 78px; max-width: calc(100vw - 16px); overflow-x: auto; padding: 7px 10px 5px; border-radius: 4px; }
    :global(.dock::before) { left: 0; right: 0; height: 56px; clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%); border-radius: 4px; }
    :global(.dock::after) { display: none; }
    :global(.dock.autohide) { bottom: 8px; opacity: 1; transform: none; }
    :global(.dock.autohide .dock-item), :global(.dock.autohide .dock-divider) { pointer-events: auto; }
    :global(.dock-item:hover), :global(.dock-item:active) { transform: none; }
    :global(.dock-icon) { -webkit-box-reflect: unset; }
    :global(.dock-icon .os-icon) { width: 42px; height: 42px; }
  }
</style>
